import { uniqBy } from 'lodash';
import { Company, UserType } from 'api/models';
import { Project, ProjectForRm } from 'api/project';
import { Task } from 'api/tasks';
import { currentUserState } from './current-user-state';

export const isCurrentUserTypeExternal = () =>
  currentUserState.userState?.currentUser.user.userType === UserType.External;

export const isNonStrategicCompany = (company: Company): boolean =>
  company.strategic === false;

const updateCompanyIfNonStrategic = (company: Company) => {
  const vendorCompany = currentUserState.userState?.vendorCompany;

  return vendorCompany != null && isNonStrategicCompany(company)
    ? vendorCompany
    : company;
};

export const updateTaskAssigneeAndResponsibleCompany = (task: Task): Task => {
  try {
    return isCurrentUserTypeExternal()
      ? {
          ...task,
          assignee: task.assignee && {
            users: task.assignee.users.map((user) => ({
              ...user,
              company: updateCompanyIfNonStrategic(user.company),
            })),
            teams: task.assignee?.teams,
          },
          responsible: uniqBy(
            task.responsible.map((company) =>
              updateCompanyIfNonStrategic(company),
            ),
            'companyId',
          ),
        }
      : task;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return task;
  }
};
export const updateTasksAssigneeAndResponsibleCompany = (
  tasks: Task[],
): Task[] => {
  try {
    return isCurrentUserTypeExternal()
      ? tasks.map(updateTaskAssigneeAndResponsibleCompany)
      : tasks;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return tasks;
  }
};

const updateProjectPartners = (
  project: ProjectForRm,
): Project | ProjectForRm => {
  try {
    return isCurrentUserTypeExternal()
      ? {
          ...project,
          partners: (project.partners ?? []).filter((x) =>
            isNonStrategicCompany(x),
          ),
        }
      : project;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return project;
  }
};

export const updateProjectsPartners = (
  projects: ProjectForRm[],
): Project[] | ProjectForRm[] => {
  try {
    return isCurrentUserTypeExternal()
      ? projects.map(updateProjectPartners)
      : projects;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return projects;
  }
};
